/* [PATCH aplikacije-fe v1] /app/:aplikacija — nastavi kontekst in odloči podjetje:
   >1 podjetje -> /izbira-podjetja; 1 -> nastavi in takoj na cilj (D5); 0 -> /podjetja.
   ?obdrzi=1 (menjava aplikacije iz glave): trenutno podjetje ostane, če je še na seznamu (Q9). */
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Loader } from 'lucide-react';
import { api } from '../lib/api';
import { useAuthStore } from '../stores/authStore';
import { ciljAplikacije, opisAplikacije, shraniAplikacijo } from '../aplikacije';
import { useMojeAplikacije } from '../hooks/useAplikacija';

export function VstopAplikacijeRuta() {
  const { aplikacija } = useParams();
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const { selectedCompany, setSelectedCompany } = useAuthStore();
  const { podatki, loading, napaka, dovoljene } = useMojeAplikacije(); // [PATCH pravice-app-podjetje v1] podatki
  const [sporocilo, setSporocilo] = useState<string | null>(null);

  useEffect(() => {
    if (loading) return;
    const opis = opisAplikacije(aplikacija);
    if (napaka || !opis || !opis.aktivna || !dovoljene.includes(opis.id)) { navigate('/', { replace: true }); return; }
    shraniAplikacijo(opis.id);
    let ziv = true;
    api.get('/companies/').then((r: any) => {
      if (!ziv) return;
      const _vsi: any[] = r.data || [];
      const _dovP = podatki?.podjetja_po_aplikaciji?.[opis.id]; // [PATCH pravice-app-podjetje v1] samo podjetja s to aplikacijo
      const seznam: any[] = _dovP ? _vsi.filter((c) => _dovP.includes(String(c.id))) : _vsi;
      const obdrzi = sp.get('obdrzi') === '1' && selectedCompany && seznam.some((c) => c.id === selectedCompany.id);
      if (obdrzi) { navigate(ciljAplikacije(opis.id), { replace: true }); return; }
      if (seznam.length === 1) { setSelectedCompany(seznam[0]); navigate(ciljAplikacije(opis.id), { replace: true }); return; }
      if (seznam.length === 0) { setSelectedCompany(null); navigate('/podjetja', { replace: true }); return; }
      navigate('/izbira-podjetja', { replace: true });
    }).catch(() => { if (ziv) setSporocilo('Podjetij ni bilo mogoče naložiti.'); });
    return () => { ziv = false; };
  }, [loading, napaka, aplikacija]); // odvisnosti namenoma ozke (projekt nima react-hooks eslint vticnika)

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
      {sporocilo ? <p className="text-red-600">{sporocilo}</p> : <Loader className="w-8 h-8 text-blue-500 animate-spin" />}
    </div>
  );
}
